export const exchangeRates = [
  { code: 'USD', flag: '🇺🇸', name: 'US Dollar', buy: 298.5, sell: 308.2 },
  { code: 'GBP', flag: '🇬🇧', name: 'British Pound', buy: 378.1, sell: 392.45 },
  { code: 'EUR', flag: '🇪🇺', name: 'Euro', buy: 322.75, sell: 335.6 },
  {
    code: 'AUD',
    flag: '🇦🇺',
    name: 'Australian Dollar',
    buy: 192.3,
    sell: 201.85,
  },
  { code: 'JPY', flag: '🇯🇵', name: 'Japanese Yen', buy: 1.92, sell: 2.04 },
  { code: 'INR', flag: '🇮🇳', name: 'Indian Rupee', buy: 3.52, sell: 3.68 },
  {
    code: 'SGD',
    flag: '🇸🇬',
    name: 'Singapore Dollar',
    buy: 220.4,
    sell: 230.15,
  },
  { code: 'CHF', flag: '🇨🇭', name: 'Swiss Franc', buy: 336.2, sell: 348.9 },
  {
    code: 'CAD',
    flag: '🇨🇦',
    name: 'Canadian Dollar',
    buy: 215.8,
    sell: 224.65,
  },
  { code: 'AED', flag: '🇦🇪', name: 'UAE Dirham', buy: 81.3, sell: 84.75 },
  { code: 'SAR', flag: '🇸🇦', name: 'Saudi Riyal', buy: 79.55, sell: 82.9 },
  {
    code: 'NZD',
    flag: '🇳🇿',
    name: 'New Zealand Dollar',
    buy: 178.2,
    sell: 186.4,
  },
]

export const goldRates = {
  k24: { perGram: 31500, perSovereign: 252000, change: +0.42 },
  k22: { perGram: 28875, perSovereign: 231000, change: +0.38 },
  k21: { perGram: 27562, perSovereign: 220500, change: +0.35 },
}

export type DepositRow = {
  tenure: string
  rate: number
  aer: number
  senior?: number
}

export const depositRates: DepositRow[] = [
  { tenure: '1 Month', rate: 7.25, aer: 7.49, senior: 7.75 },
  { tenure: '3 Months', rate: 8.0, aer: 8.24, senior: 8.5 },
  { tenure: '6 Months', rate: 8.75, aer: 8.94, senior: 9.25 },
  { tenure: '9 Months', rate: 9.1, aer: 9.31, senior: 9.6 },
  { tenure: '12 Months', rate: 9.5, aer: 9.5, senior: 10.0 },
  { tenure: '18 Months', rate: 9.65, aer: 9.78, senior: 10.15 },
  { tenure: '24 Months', rate: 9.75, aer: 9.75, senior: 10.25 },
  { tenure: '36 Months', rate: 10.0, aer: 10.0, senior: 10.5 },
  { tenure: '48 Months', rate: 10.15, aer: 10.15, senior: 10.65 },
  { tenure: '60 Months', rate: 10.25, aer: 10.25, senior: 10.75 },
]

export const kpis = [
  {
    label: 'Total Assets',
    value: 'LKR 2.4 Tn',
    numeric: 2.4,
    max: 3,
    suffix: 'Tn',
    delta: '+8.6%',
  },
  {
    label: 'Deposit Growth',
    value: '+12.4%',
    numeric: 12.4,
    max: 20,
    suffix: '%',
    delta: 'YoY',
  },
  {
    label: 'Loan Portfolio',
    value: 'LKR 1.6 Tn',
    numeric: 1.6,
    max: 2.5,
    suffix: 'Tn',
    delta: '+6.2%',
  },
  {
    label: 'CASA Ratio',
    value: '38.2%',
    numeric: 38.2,
    max: 50,
    suffix: '%',
    delta: '+1.4 pts',
  },
  {
    label: 'Customer Base',
    value: '4.8M+',
    numeric: 4.8,
    max: 6,
    suffix: 'M',
    delta: '+340K',
  },
]

export const worldClockCities = [
  { city: 'Colombo', tz: 'Asia/Colombo', flag: '🇱🇰' },
  { city: 'London', tz: 'Europe/London', flag: '🇬🇧' },
  { city: 'New York', tz: 'America/New_York', flag: '🇺🇸' },
  { city: 'Tokyo', tz: 'Asia/Tokyo', flag: '🇯🇵' },
  { city: 'Dubai', tz: 'Asia/Dubai', flag: '🇦🇪' },
  { city: 'Singapore', tz: 'Asia/Singapore', flag: '🇸🇬' },
]

export const noticeText =
  'Special Notice: Branches will operate on extended hours during the Vesak season. • ComBank Digital — banking at your fingertips, 24/7. • New mobile app update now available on the App Store and Google Play. • Contact our 24-hour Hotline 011 2 363 363 for any banking assistance.'
